import Vue from 'vue'
import App from './App'
import VueGtm from 'vue-gtm'
import router from './router'
import jQuery from 'jquery'
import 'blueimp-gallery/css/blueimp-gallery.css'
import {Tabs, Tab} from 'vue-tabs-component'
import VModal from 'vue-js-modal'
import 'bootstrap'
import { VPopover } from 'v-tooltip'

Vue.component('v-popover', VPopover)

window.jQuery = jQuery
window.$ = jQuery
global.jQuery = jQuery

Vue.config.productionTip = false

Vue.component('tabs', Tabs)
Vue.component('tab', Tab)
Vue.use(VModal)

Vue.use(VueGtm, {
  enabled: true,
  debug: false,
  vueRouter: router
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title !== undefined ? to.meta.title : 'Oxynov'
  document.head.querySelector('meta[name=description]').content = to.meta.description !== undefined ? to.meta.description : 'Oxynov description'
  document.head.querySelector('meta[name=keywords]').content = to.meta.keywords !== undefined ? to.meta.keywords : 'Oxynov keywords'
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js